import { Injectable, signal } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {LocalStorageService} from "../local-storage/local-storage.service";
import {BehaviorSubject, Observable, of, single, tap} from "rxjs";
import {ActivatedRouteSnapshot, Router} from "@angular/router";
import { environment } from '../../../environments/environment';
import { ExternalUser } from '../../domain/model/account/externalUser';
import { jwtDecode } from 'jwt-decode';
import { SecureTokenService } from '../../core/native/secure-token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private apiUrl = `${environment.apiUrl}/external`;
  private _currentUser! :ExternalUser;
  private currentUser= signal<ExternalUser>(this._currentUser);
  private isAuthenticated = signal(false)
  private TOKEN_NAME: string = 'appToken';

  private userSubject = new BehaviorSubject<ExternalUser | undefined>(undefined);

  constructor(private readonly router: Router,private http: HttpClient,
              private readonly localStorage: LocalStorageService,
              private readonly secureToken: SecureTokenService) { }
              httpOptions = {
                headers: new HttpHeaders({
                  'Content-Type':  'application/json',
                   'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
                })
              };
  loginUser(email: string, password: string): Observable<ExternalUser> {
    const url = `${this.apiUrl}/login`;
    return this.http.post<ExternalUser>(url, { email, password },this.httpOptions)
      .pipe(tap(user => {
        if (user) {
          this.localStorage.set("appToken", user.token);
          // Persist to the OS keystore on native (no-op on web).
          this.secureToken.setToken(user.token);
          this.currentUser.set(user);
          this.isAuthenticated.set(true)
        }
      }));
  }
  getToken(): string | null {
    return localStorage.getItem('appToken');
  }

  validateToken(): Observable<boolean> {
    const token = this.localStorage.get(this.TOKEN_NAME)

    return token && !token;
  }

  validateAuthorization(route: ActivatedRouteSnapshot, token: string): Observable<boolean>{
    return of(token === "foo");
  }
  getCurrentUser2(): ExternalUser | null {
    const token = this.getToken();
    return token ? jwtDecode(token) : null
  }

  getCurrentUser(): ExternalUser {

    return this.currentUser();
  }
  
  isLoggedIn() : boolean {
    return this.isAuthenticated();
  }

  logout() {
    this.localStorage.remove(this.TOKEN_NAME);
    // The payment cart belongs to the session that built it.
    try { sessionStorage.removeItem('tdt.web.basket'); } catch { /* unavailable */ }
    // Clear the keystore-backed session on native (no-op on web).
    this.secureToken.clear();
    this.userSubject.next(undefined);
  }
}


